import type { PutMetricDataCommandInput } from "@aws-sdk/client-cloudwatch";
import { Config } from "services/configuration/eatSmartConfig";
import { getFridgeId } from "utils/browser/localStorage";
import { log, logToSentry } from "utils/logger";

const fridgeId = getFridgeId();
const { aws } = Config;

const keepAliveMetric: PutMetricDataCommandInput = {
	Namespace: "TerminalUptimeMonitoring",
	MetricData: [
		{
			MetricName: "Uptime",
			Dimensions: [
				{
					Name: "fridgeId",
					Value: fridgeId,
				},
				{
					Name: "environment",
					Value: import.meta.env.MODE,
				},
			],
			Value: 1,
		},
	],
};

export const sendCloudwatchMetric = (sendLogs: boolean) => {
	if (sendLogs) {
		fetch(aws.cloudWatchEndpoint, {
			method: "POST",
			headers: {
				"Content-Type": "application/json",
			},
			body: JSON.stringify(keepAliveMetric),
		}).catch((e) => {
			logToSentry("Error sending cloudwatch metric", "error", e);
		});
	} else {
		log("Cloudwatch check", "info", keepAliveMetric);
	}
};
